import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { APPFLOWS } from '../../../../../constants/applicationConstants';
import { DataTableHoc, Loader, ErrorFallback } from 'smart-react';
import { GridColumnsList } from '../Filter/FilterElements';
import DataColumns from '../DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../../constants/applicationConstants';
import { deleteFilter, applyFilter, saveFilters } from 'smart-react';
const BaseAppFlowDataTable = React.lazy(() => import('./DataTable'));
const AppFlowDataTable = DataTableHoc(BaseAppFlowDataTable);

/**
 * Topbar of Test Case Lookup page
 * Includes Favourite and Recent button with Test Case Lookup search Box
 */
const TestCaseDataTableWrapper = ({
  dataSet,
  setDataSet,
  selectedTreeObj,
  selectedTree,
  topbarSearch,
  setTopBarSearch,
  isSearch,
  setIsSearch,
  setIsFilterFavourite,
  isFilterFavourite,
  setLookupCheckedItems,
  lookupCheckedItems,
  mode,
  lookupSelectionMode,
  setIsRecent,
  isRecent,
  selectLookups,
  show,
  handleTestCaseSlide,
  ...others
}) => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);
  return (
    <>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          // reset the state of your app so the error doesn't happen again
        }}
      >
        <div className='container mx-auto'>
          <React.Suspense fallback={<Loader />}>
            <AppFlowDataTable
              deleteFilter={deleteFilter}
              applyFilter={applyFilter}
              saveFilters={saveFilters}
              moduleName={APPFLOWS}
              dataColumns={dataColumnsArray}
              gridColumnsList={GridColumnsList}
              dataTableName={APPFLOWS}
              setIsReady={setIsReady}
              isReady={isReady}
              rowLayoutConfigName={`${APPFLOWS}.DataGrid.RowLayout`}
              pageLengthConfigName={`${APPFLOWS}.DataGrid.ItemsPerPage`}
              dataSet={userData}
              setDataSet={setUserData}
              initialSort={{
                field: 'id',
                dir: 'desc',
              }}
              isCardonMobileView={false}
              total={process.env.DefaultLimit}
              defaultRowLayout={process.env.RowLayout}
              rowLayouts={ROW_LAYOUTS}
              pageSizes={PAGE_SIZE}
              selectedTreeObj={selectedTreeObj}
              selectedTree={selectedTree}
              topbarSearch={topbarSearch}
              setTopBarSearch={setTopBarSearch}
              setIsSearch={setIsSearch}
              isSearch={isSearch}
              isRecent={isRecent}
              setIsRecent={setIsRecent}
              setIsFilterFavourite={setIsFilterFavourite}
              isFilterFavourite={isFilterFavourite}
              setLookupCheckedItems={setLookupCheckedItems}
              lookupCheckedItems={lookupCheckedItems}
              mode={mode}
              lookupSelectionMode={lookupSelectionMode}
              contentSliderTitle={'Eq Lookups'}
              selectLookups={selectLookups}
              show={show}
              handleTestCaseSlide={handleTestCaseSlide}
              {...others}
            />
          </React.Suspense>
        </div>
      </ErrorBoundary>
    </>
  );
};

export default TestCaseDataTableWrapper;
